"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantInVariantUpdateSuggestion = instanceOfVariantInVariantUpdateSuggestion;
exports.VariantInVariantUpdateSuggestionFromJSON = VariantInVariantUpdateSuggestionFromJSON;
exports.VariantInVariantUpdateSuggestionFromJSONTyped = VariantInVariantUpdateSuggestionFromJSONTyped;
exports.VariantInVariantUpdateSuggestionToJSON = VariantInVariantUpdateSuggestionToJSON;
exports.VariantInVariantUpdateSuggestionToJSONTyped = VariantInVariantUpdateSuggestionToJSONTyped;
/**
 * Check if a given object implements the VariantInVariantUpdateSuggestion interface.
 */
function instanceOfVariantInVariantUpdateSuggestion(value) {
    if (!('variant' in value) || value['variant'] === undefined)
        return false;
    if (!('issue' in value) || value['issue'] === undefined)
        return false;
    return true;
}
function VariantInVariantUpdateSuggestionFromJSON(json) {
    return VariantInVariantUpdateSuggestionFromJSONTyped(json, false);
}
function VariantInVariantUpdateSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'variant': json['variant'],
        'issue': json['issue'],
    };
}
function VariantInVariantUpdateSuggestionToJSON(json) {
    return VariantInVariantUpdateSuggestionToJSONTyped(json, false);
}
function VariantInVariantUpdateSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'variant': value['variant'],
        'issue': value['issue'],
    };
}
//# sourceMappingURL=variantInVariantUpdateSuggestion.js.map